import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { filter, map, Observable } from 'rxjs';
import { ILabelValue } from '../ui-lib/common-dropdawn/typing/label-value.interface';
import { IPaginatedResponse } from '../typing/response.interface';
import { ExternalPriceService } from './external-price.service';
import { IExternalPrice } from '../typing/external-price.interface';

@Injectable({
    providedIn: 'root'
})
export class ExternalPriceSelectorService {
    constructor(private externalPriceService: ExternalPriceService) {}

    getList(query: Params): Observable<IPaginatedResponse<ILabelValue>> {
        const mergedQuery = {
            ...query,
            'filter.status': 'ACTIVE',
        };
        return this.externalPriceService.getList(mergedQuery).pipe(map((response) => this.transformData(response)));
    }

    transformData(paginatedResponse: IPaginatedResponse<IExternalPrice>): IPaginatedResponse<ILabelValue> {
        const transformedData = paginatedResponse.data.map((price) => {
            return {
                label: this.buildLabel(price),
                value: price.id,
                tooltip: `${price.externalId}${price.tax ? `; НДС:${price.tax}` : ''}`,
            };
        });

        return {
            ...paginatedResponse,
            data: transformedData,
        } as IPaginatedResponse<ILabelValue>;
    }

    getOptionsByValue(optionValue: number | string): Observable<ILabelValue> {
        return this.externalPriceService.getOne(Number(optionValue)).pipe(
            filter((price) => !!price),
            map((price) => ({
                label: this.buildLabel(price),
                value: price.id,
                tooltip: `${price.externalId}${price.tax ? `; НДС:${price.tax}` : ''}`,
            })),
        );
    }

    private buildLabel(price: IExternalPrice): string {
        const category = price.categoryName ? `Категория:${price.categoryName}` : 'Категория:-';
        const externalId = `ID:${price.externalId.slice(0, 8)}`;
        return `${price.name} — ${category}; ${externalId}`;
    }
}
